"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.backfillStalenessBaselines = backfillStalenessBaselines;
const path = __importStar(require("path"));
const getState_1 = require("./getState");
async function backfillStalenessBaselines(opts, deps) {
    const state = await (0, getState_1.getState)(deps);
    const loomRoot = deps.getActiveLoomRoot(deps.workspaceRoot);
    const dryRun = !!opts.dryRun;
    const changed = [];
    const failed = [];
    let scanned = 0;
    const rel = (p) => path.relative(loomRoot, p);
    for (const weave of state.weaves) {
        for (const thread of weave.threads) {
            const threadPath = path.join(loomRoot, 'loom', weave.id, thread.id);
            // design <- idea: stamp design.idea_version = idea.version, and strip the
            // dead `req_version` (a design no longer depends on the req — the field was
            // removed from the model). The design is re-saved either way, so it's free.
            if (thread.design && thread.idea) {
                scanned++;
                const designPath = thread.design._path ?? path.join(threadPath, 'design.md');
                const needsIdeaVersion = thread.design.idea_version !== thread.idea.version;
                const staleReqVersion = thread.design.req_version;
                const hasDeadReqVersion = staleReqVersion !== undefined;
                if (needsIdeaVersion || hasDeadReqVersion) {
                    try {
                        if (!dryRun) {
                            const d = (await deps.loadDoc(designPath));
                            d.idea_version = thread.idea.version;
                            delete d.req_version;
                            await deps.saveDoc(d, designPath);
                        }
                        if (needsIdeaVersion)
                            changed.push({ path: rel(designPath), field: 'idea_version', from: thread.design.idea_version, to: thread.idea.version });
                        if (hasDeadReqVersion)
                            changed.push({ path: rel(designPath), field: 'req_version', from: staleReqVersion, to: 'removed' });
                    }
                    catch (e) {
                        failed.push({ path: rel(designPath), error: e?.message ?? String(e) });
                    }
                }
            }
            // req <- design: stamp req.design_version = design.version, repoint parent
            if (thread.req && thread.design) {
                scanned++;
                const reqPath = path.join(threadPath, 'req.md');
                const needsVersion = thread.req.design_version !== thread.design.version;
                const needsParent = thread.req.parent_id !== thread.design.id;
                if (needsVersion || needsParent) {
                    try {
                        if (!dryRun) {
                            const r = (await deps.loadDoc(reqPath));
                            r.design_version = thread.design.version;
                            r.parent_id = thread.design.id;
                            await deps.saveDoc(r, reqPath);
                        }
                        if (needsVersion)
                            changed.push({ path: rel(reqPath), field: 'design_version', from: thread.req.design_version, to: thread.design.version });
                        if (needsParent)
                            changed.push({ path: rel(reqPath), field: 'parent_id', from: thread.req.parent_id, to: thread.design.id });
                    }
                    catch (e) {
                        failed.push({ path: rel(reqPath), error: e?.message ?? String(e) });
                    }
                }
            }
        }
    }
    return { changed, scanned, failed, dryRun };
}
